import { Modal } from "@mui/joy";
import { ComponentType } from "react";

import { MODAL_REGISTRY } from "./registry";
import { useModal } from "./useModal";

export const ModalLauncher = () => {
  const { isOpen, modalId, params, close } = useModal();

  // useModal's display() ties each modal id to its params, but the registry
  // lookup here sees every modal at once, so treat the props as opaque.
  const ContentsComponent = modalId ? (MODAL_REGISTRY[modalId] as ComponentType<object>) : null;

  return (
    <Modal open={isOpen} onClose={close} key={modalId}>
      <>{ContentsComponent ? <ContentsComponent {...(params ?? {})} /> : null}</>
    </Modal>
  );
};
